import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Col, Row } from 'react-bootstrap'

import { sendAuth } from '../../api/Api'
import logo from '../../icon/logo.svg'
import styles from './styles.module.scss'

const Login: React.FC = () => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [remember, setRemember] = useState(false)
  const navigate = useNavigate()

  const handleLogin = () => {
    const data = {
      email: email,
      password: password,
    }

    sendAuth(data)
      .then(res => {
        console.log('res: ', res.data)
        const storage = remember ? localStorage : sessionStorage
        const noStorage = !remember ? localStorage : sessionStorage
        storage.setItem('token', res.data.access_token)
        noStorage.removeItem('token')

        navigate('dashboard')
      })
      .catch(e => {
        console.log('e: ', e)
      })
  }

  return (
    <div className={styles.mainWrapper}>
      <div className={styles.pageWrapper}>
        <div className={styles.pageContent}>
          <Row className={styles.authPage}>
            <Col md="8" xl="6" className="mx-auto">
              <div className={styles.card}>
                <Row>
                  <Col md="4" className="pe-md-0">
                    <div className={styles.authSideWrapper} />
                  </Col>
                  <Col md="8" className="ps-md-0">
                    <div className="auth-form-wrapper px-4 py-5">
                      <img src={logo} alt="logo" width={315} />
                      <h5 className="text-muted fw-normal mb-4">
                        Welcome back! Log in to your account.
                      </h5>
                      <form className="forms-sample">
                        <div className="mb-3">
                          <label htmlFor="userEmail" className="form-label">
                            Email address
                          </label>
                          <input
                            type="email"
                            className="form-control"
                            id="userEmail"
                            placeholder="Email"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                          />
                        </div>
                        <div className="mb-3">
                          <label htmlFor="userPassword" className="form-label">
                            Password
                          </label>
                          <input
                            type="password"
                            className="form-control"
                            id="userPassword"
                            autoComplete="current-password"
                            placeholder="Password"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                          />
                        </div>
                        <div className="form-check mb-3">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="authCheck"
                            onChange={() => setRemember(prevRemember => !prevRemember)}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="authCheck">
                            Remember me
                          </label>
                        </div>
                        <div
                          onClick={handleLogin}
                          className="btn btn-primary me-2 mb-2 mb-md-0 text-white">
                          Login
                        </div>
                        <Link
                          to={'/register'}
                          className="d-block mt-3 text-muted">
                          Not a user? Sign up
                        </Link>
                      </form>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  )
}

export default Login
